import { combineReducers } from 'redux';

import auth from './auth';
import form from './form';
import bookMark from './bookMark';
import commons from './commons';
import company from './company';
import sikdae from './sikdae';
import settlement from './settlement';
import etc from './etc';
import usage from './usage';
import dashboard from './dashboard';
import booking from './booking';
import holiday from './holiday';
import paymentReason from './paymentReason';
import captainPayment from './captainPayment';
import member from './member';

const reducers = {
  auth,
  form,
  bookMark,
  commons,
  company,
  sikdae,
  settlement,
  etc,
  usage,
  dashboard,
  booking,
  holiday,
  paymentReason,
  captainPayment,
  member
};

export default combineReducers(reducers);
